@if (componentLoaded) {
  <div class="d-flex mb-3 w-100 overflow-auto">
    @if (dataSource.length > 0) {
    <table class="table table-responsive">
      <thead>
        <tr>
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('anno')"
            title="Anno"
          >
            <div class="d-flex align-items-center">
              Anno
              <div class="ms-1 position-relative min-height-th-home">
                <i class="bi position-absolute top-0" [ngClass]="getCaretClass('anno', false)"></i>
                <i class="bi position-absolute bottom-0" [ngClass]="getCaretClass('anno', true)"></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('mese')"
            title="Mese"
          >
            <div class="d-flex align-items-center">
              Mese
              <div class="ms-1 position-relative min-height-th-home">
                <i class="bi position-absolute top-0" [ngClass]="getCaretClass('mese', false)"></i>
                <i class="bi position-absolute bottom-0" [ngClass]="getCaretClass('mese', true)"></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('nomeDelegante')"
            title="Delegante"
          >
            <div class="d-flex align-items-center">
              Delegante
              <div class="ms-1 position-relative min-height-th-home">
                <i class="bi position-absolute top-0" [ngClass]="getCaretClass('nomeDelegante', false)"></i>
                <i class="bi position-absolute bottom-0" [ngClass]="getCaretClass('nomeDelegante', true)"></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('nomeDelegato')"
            title="Delegato"
          >
            <div class="d-flex align-items-center">
              Delegato
              <div class="ms-1 position-relative min-height-th-home">
                <i class="bi position-absolute top-0" [ngClass]="getCaretClass('nomeDelegato', false)"></i>
                <i class="bi position-absolute bottom-0" [ngClass]="getCaretClass('nomeDelegato', true)"></i>
              </div>
            </div>
          </th>
          <th
            class="table-column-max-width text-slate-800"
            scope="col"
            role="button"
            (click)="sort('dataOraCreazione')"
            title="Data/Ora Delega"
          >
            <div class="d-flex align-items-center">
              Data/Ora Delega
              <div class="ms-1 position-relative min-height-th-home">
                <i class="bi position-absolute top-0" [ngClass]="getCaretClass('dataOraCreazione', false)"></i>
                <i class="bi position-absolute bottom-0" [ngClass]="getCaretClass('dataOraCreazione', true)"></i>
              </div>
            </div>
          </th>
          <th class="table-column-max-width text-slate-800" scope="col" style="max-width: 80px">
            Azioni
          </th>
        </tr>
      </thead>
      <tbody>
        @for (element of dataSource; track element.id) {
        <tr>
          <td class="table-column-max-width text-slate-700">
            {{ element.anno }}
          </td>
          <td class="table-column-max-width text-slate-700">
            {{ element.descrizionePeriodo }}
          </td>
          <td class="table-column-max-width">
            <span class="fw-semibold" [matTooltip]="element.nomeDelegante ?? ''">
              {{ element.nomeDelegante }}
            </span>
            <br />
            <span class="text-slate-700">{{ element.matricolaDelegante }}</span>
          </td>
          <td class="table-column-max-width">
            <span class="fw-semibold" [matTooltip]="element.nomeDelegato ?? ''">
              {{ element.nomeDelegato }}
            </span>
            <br />
            <span class="text-slate-700">{{ element.matricolaDelegato }}</span>
          </td>
          <td class="table-column-max-width text-slate-700">
            {{ element.dataOraCreazione }}
          </td>
          <td class="table-column-max-width">
            @if (element.attivo && element.idAnagraficaTimesheet === idAnagraficaTimesheetCorrente) {
            <a
              class="text-decoration-none text-primary"
              (click)="onDisattiva(element)"
              onclick="return false"
              matTooltip="Cancella delega"
              href="/"
            >
              <i class="bi bi-trash-fill fs-5 me-2"></i>
            </a>
            }
          </td>
        </tr>
        }
      </tbody>
    </table>
    } @else {
    <p class="w-100 text-center">Nessuna delega trovata</p>
    }
  </div>
  <div class="d-flex justify-content-between align-items-center">
    <span class="text-slate-700 ps-3 mb-3">
      {{
        elencoCount > 0
          ? elencoCount > 1
            ? elencoCount + " deleghe trovate"
            : elencoCount + " delega trovata"
          : ""
      }}
    </span>

    <pagination
      *ngIf="totalPages > 0"
      alignment="end"
      [currentPage]="currentPage"
      [pageNumbers]="totalPages"
      [currentChanger]="pageOffset"
      (changerEvent)="changerEvent($event)"
      (pageEvent)="getPage($event)"
    >
    </pagination>
  </div>
}
